<template lang="pug">
  v-container(fluid)
    p Torneos
    p Pendiente
</template>

<script>
  export default {
    name: "Tournaments",
    components: {
    },
    data:() => ({
    }),
    computed: {
    },
    created(){
    },
    methods:{
    },
  }
</script>

<style lang="sass">
</style>